// src/store/slices/loginMetaSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginMetaState } from "../../../Interfaces/ReduxSliceInterface";


const initialState: LoginMetaState = {
  emailOtpRequired: true,
  loginToken: "",
  devCode: "",
};

const loginMetaSlice = createSlice({
  name: "loginMeta",
  initialState,
  reducers: {
    setLoginMeta: (
      state,
      action: PayloadAction<{
        emailOtpRequired: boolean;
        loginToken: string;
        devCode: string;
      }>
    ) => {
      state.emailOtpRequired = action.payload.emailOtpRequired;
      state.loginToken = action.payload.loginToken;
      state.devCode = action.payload.devCode;
    },
    clearLoginMeta: (state) => {
      state.emailOtpRequired = true;
      state.loginToken = "";
      state.devCode = "";
    },
  },
});

export const { setLoginMeta, clearLoginMeta } = loginMetaSlice.actions;
export default loginMetaSlice.reducer;
